import React from 'react';
import { CloseIcon } from '@yme/assets/icons';
import { Button, SIZE_36, TEXT_VARIANT, ICON_ONLY } from '@yme/atoms/button';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { MODAL_CLOSE_ICON_ID } from './constants';
import { ModalWindowHeaderStyled } from './styled';
export function ModalWindowHeader({ isRightToLeft, title, onHide, hasCloseButton, }) {
    const { t } = useTranslation();
    return (React.createElement(ModalWindowHeaderStyled, { isRightToLeft: isRightToLeft },
        React.createElement(RegularTextLevel3, { "data-testid": MODAL_CLOSE_ICON_ID, weight: 500, as: "h2", color: colorCoreBlack900Base }, title),
        hasCloseButton ? (React.createElement(Button, { onClick: onHide, size: SIZE_36, hasIconButton: ICON_ONLY, buttonVariant: TEXT_VARIANT, iconComponent: CloseIcon, width: "auto", tabIndex: 0, "aria-label": t('common_cancel_button') })) : null));
}
